/** @jsx jsx */

import React, {
  Fragment as _,
  ReactElement,
  useContext,
  useRef,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
interface FlipcardsProps {
  children: ReactElement[];
}

const Flipcards = (props: FlipcardsProps) => {
  const { children } = props;
  const context = useContext(interactionContext);

  const itemsSeen = useRef(
    unlockInteraction(context.id, (children as any).length)
  );

  const updateFlipCardSeen = id => {
    if (context.props.lockDown === 0) return;
    itemsSeen.current(id);
  };

  return (
    <div
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
      `}
    >
      <span
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          overflow: hidden;
        `}
      >
        Click a button to change the content
      </span>

      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        `}
        role="list"
      >
        {children.map((child: any, index) =>
          React.cloneElement(child, {
            updateFlipCardSeen,
            numFlipCards: children.length,
            index,
          })
        )}
      </div>
    </div>
  );
};

export default Flipcards;
